import React, { useEffect, useState } from 'react';
import { Notification } from '@carbon/icons-react';
import {
  Header,
  HeaderContainer,
  HeaderGlobalAction,
  HeaderGlobalBar,
  HeaderMenuButton,
  HeaderName,
  SkipToContent,
  Theme,
} from '@carbon/react';
import { isLoggedIn } from '../Utils/common';
import { firstCharUpperCase } from '../Utils/Regex';
import Sidebar from '../Components/Pages/Sidebar';

export const Layout = () => {
  const [authType, setAuthType] = useState(null);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const info = isLoggedIn();
    setUserData(info);
    setAuthType(info?.role);
  }, []);

  return (
    <>
      <HeaderContainer
        render={({ isSideNavExpanded, onClickSideNavExpand }) => (
          <>
            <Theme theme="g100">
              <Header aria-label="IBM Platform Name">
                <SkipToContent />
                <HeaderMenuButton
                  aria-label="Open menu"
                  onClick={onClickSideNavExpand}
                  isActive={isSideNavExpanded}
                />
                <HeaderName prefix="IBM">
                  [Platform]{' '}
                  {authType &&
                    `Welcome ${userData?.name} - ${firstCharUpperCase(
                      authType
                    )}`}
                </HeaderName>
                <HeaderGlobalBar className="notification-icon">
                  <HeaderGlobalAction
                    aria-label="Notifications"
                    onClick={() => {}}
                  >
                    <Notification />
                  </HeaderGlobalAction>
                </HeaderGlobalBar>
              </Header>
            </Theme>
            <div>
              <Sidebar />
            </div>
          </>
        )}
      />
    </>
  );
};
